import {Routes} from '@angular/router';

export const acceptManagementRoutes: Routes = [
  {
    path: 'acceptManagement',
    data: { title: '接单管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./accept-management.component').then(m => m.AcceptManagementComponent),
        data: { title: '接单管理' },
      },
      {
        path: 'addAcceptDetail',
        loadComponent: () => import('./add-accept-detail/add-accept-detail.component').then(m => m.AddAcceptDetailComponent),
        data: { title: '接单明细' },
      },
      {
        path: 'acceptDetail/:acceptOrderId',
        loadComponent: () => import('./accept-detail/accept-detail.component').then(m => m.AcceptDetailComponent),
        data: { title: '接单明细' },
      },
    ]
  },
];
